<template>
  <v-chip :color="statusColor" :dark="statusDark" small label>
    <v-icon left x-small>{{ statusIcon }}</v-icon>
    {{ statusText }}
  </v-chip>
</template>

<script>
export default {
  name: "ShiftStatusBadge",
  props: {
    status: {
      type: String,
      required: true,
      validator: (value) =>
        [
          "active",
          "completed",
          "interrupted",
          "pending_approval",
          "approved",
          "rejected",
        ].includes(value),
    },
  },
  computed: {
    statusColor() {
      const colors = {
        active: "green",
        completed: "blue",
        interrupted: "orange",
        pending_approval: "amber",
        approved: "green",
        rejected: "red",
      };
      return colors[this.status] || "grey";
    },
    statusDark() {
      return ["active", "pending_approval", "approved", "rejected"].includes(
        this.status
      );
    },
    statusIcon() {
      const icons = {
        active: "fas fa-clock",
        completed: "fas fa-check-circle",
        interrupted: "fas fa-exclamation-triangle",
        pending_approval: "fas fa-hourglass-half",
        approved: "fas fa-check-circle",
        rejected: "fas fa-times-circle",
      };
      return icons[this.status] || "fas fa-question-circle";
    },
    statusText() {
      return this.$t(`shift_status_${this.status}`);
    },
  },
};
</script>
